<script>
export default {
  name: "ExpandableTable",
  data: () => ({
    expanded: false,
  }),
  computed: {
    tableItems() {
      if(this.items.length <= 10 || this.expanded) return this.items;
      return this.items.slice(0, 10);
    },
    hasMoreItems() {
      return this.items.length > 10;
    },
    sum() {
      return this.items.reduce((acc, item) => acc + item.count, 0);
    },
  },
  props: {
    nameHeader: {
      type: String,
      default: 'Name',
    },
    valueHeader: {
      type: String,
      default: 'Anzahl',
    },
    items: {
      type: Array,
      required: true,
    },
    nameKey: {
      type: String,
      default: 'name',
    },
  },
}
</script>

<template>
  <div>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th>#</th>
        <th class="text-left">{{ nameHeader }}</th>
        <th class="text-right">{{ valueHeader }}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td></td>
        <td class="text-left"><strong>Gesamt</strong></td>
        <td class="text-right"><strong>{{ sum }}</strong></td>
      </tr>
      <tr v-for="(item, index) in tableItems" :key="index">
        <td>{{ index + 1}}</td>
        <td>{{ item[nameKey] }}</td>
        <td class="text-right">{{ item.count }}</td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
    <v-btn v-if="hasMoreItems" small @click="expanded = !expanded" style="width: 100%;" depressed color="primary" class="my-2">
      {{ expanded ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
    </v-btn>
  </div>
</template>

<style scoped>

</style>